import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import FamilyViewPopup from './familyViewPopup';
import EditFamily from './editFamily';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

class FamilyBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showViewPopup: false,
            showEditPopup: false
        };
    }

    handleView = () => {
        this.setState({ showViewPopup: true });
        // Track recent view
        const family = this.props.data;
        if (family) {
            trackRecentView('family', family._id, family.family_name || 'Family', '/clinic/families');
        }
    };

    handleEdit = () => {
        this.setState({ showEditPopup: true });
    };

    renderTooltipView = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            View Family
        </Tooltip>
    );

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Family
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipView}>
                    <button onClick={this.handleView} style={{ border: 'none', backgroundColor: 'transparent' }}>
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>

                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleEdit} style={{ border: 'none', backgroundColor: 'transparent' }}>
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>

                <FamilyViewPopup
                    show={this.state.showViewPopup}
                    handleClose={() => this.setState({ showViewPopup: false })}
                    data={this.props.data}
                    context={this.props.context}
                />
                <EditFamily
                    show={this.state.showEditPopup}
                    handleClose={() => this.setState({ showEditPopup: false })}
                    data={this.props.data}
                    loadGridData={this.props.context.componentParent.loadGridData}
                />
            </div>
        );
    }
}

export default FamilyBtnCellRenderer;